import React from "react";

export function Diagnosis(props) {

    const {diagnosisSet, title} = props;

    if (!diagnosisSet) {
        return (
            <></>
        );
    }

    return (<span style={{marginLeft: "1rem"}}>
		{title}:{' '}
            {diagnosisSet.ungradable && 'U '}
            {diagnosisSet.maculopathyClassification != null && 'M' + diagnosisSet.maculopathyClassification + ' '}
            {diagnosisSet.retinopathyClassification != null && 'R' + diagnosisSet.retinopathyClassification + ' '}
	</span>
    );
}
